import cloneDeep from 'lodash.clonedeep'
import React, { FunctionComponent, useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'

import * as PT from 'modules/Pricing/types'

import Spacer from 'components/Spacer'

import { useWindowSize } from 'services/hooks'

import * as T from 'types'

import { getSortedDisclosures, getUniqueFeatures } from '../utils'

const Container = styled.div`
  text-align: center;
  padding: 16px;
  font-weight: 500;
  font-size: 14px;
  line-height: 19px;
  color: ${props => props.theme.colors.neutral600};

  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    padding: 16px 12px;
    line-height: 20px;
  }
`

interface IBold {
  bold?: boolean
}
const RequiredFeesText = styled.div<IBold>`
  ${props => props.bold && 'font-weight: bold'};
`

interface IProps {
  featuresExclusive: PT.IFeatures
  selectedState?: T.IState | null
}

const PackageDisclaimer: FunctionComponent<IProps> = ({ featuresExclusive, selectedState }) => {
  const theme = useContext(ThemeContext)
  const { width } = useWindowSize()
  const isMobile = width && width < theme.metrics.tablet

  const features = cloneDeep(featuresExclusive)
  Object.keys(features).forEach(key => {
    features[key] = features[key].filter(feature => feature.included)
  })

  const uniqueFeatures = getUniqueFeatures(Object.values(features))
  const disclaimers = getSortedDisclosures(uniqueFeatures) as string[]

  return (
    <Container>
      {/* Link to UT and SC pricing pages will be added in the future */}
      {/* {' '}
      <StyledLink>
        <Anchor
          data-testid="disclaimer"
          href="https://www.facebook.com/HomeLister"
          target="_blank"
        >
          Click here
        </Anchor>
      </StyledLink>
      {' '}
      for different plans specific to your market.
      <Spacer size={16} /> */}
      {(!selectedState || selectedState.abbreviation === 'GA') && (
        <>
          <RequiredFeesText bold={!!isMobile}>Required Fees:</RequiredFeesText>
          <div>{isMobile ? 'GA' : 'Georgia'}: FMLS 0.12% Commission Fee due at Closing</div>
          <Spacer size={16} />
        </>
      )}
      {disclaimers.map((disclaimer, index) => (
        <div
          key={disclaimer}
          id={`${disclaimer?.replace(/\s+/g, '-')}`}
        >
          {`${'*'.repeat(index + 1)} ${disclaimer}`}
        </div>
      ))}
    </Container>
  )
}

export default PackageDisclaimer
